import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
  TASK_EMPLOYEE_LIST, TASK_EMPLOYEE_ADD, TASK_EMPLOYEE_DETAIL,
  TASK_EMPLOYEE_UPDATE, TASK_EMPLOYEE_FILTER_EMPLOYEES,
} from '../../actions';
import {
  TaskEmployeeListSuccess, TaskEmployeeListError,
  TaskEmployeeAddSuccess, TaskEmployeeAddError,
  TaskEmployeeDetailSuccess, TaskEmployeeDetailError,
  TaskEmployeeUpdateSuccess, TaskEmployeeUpdateError,
  TaskEmployeeFilterEmployeesSuccess,
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/employee/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/employee/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/employee/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/employee/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onFilterEmployeesAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'task/employee/filter_employees', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(TaskEmployeeListSuccess(response.data)); }
  catch (error) { yield put(TaskEmployeeListError(error)); }
}

function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(TaskEmployeeAddSuccess(response.data));
  } catch (error) { yield put(TaskEmployeeAddError(error)); }
}

function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(TaskEmployeeDetailSuccess(response.data.data)); }
  catch (error) { yield put(TaskEmployeeDetailError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(TaskEmployeeUpdateSuccess(response.data));
  } catch (error) { yield put(TaskEmployeeUpdateError(error)); }
}

function* onFilterEmployees(data) {
  try { const response = yield call(onFilterEmployeesAsync, data.payload); yield put(TaskEmployeeFilterEmployeesSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(TASK_EMPLOYEE_LIST, onList); }
export function* watchAdd() { yield takeEvery(TASK_EMPLOYEE_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(TASK_EMPLOYEE_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(TASK_EMPLOYEE_UPDATE, onUpdate); }
export function* watchFilterEmployees() { yield takeEvery(TASK_EMPLOYEE_FILTER_EMPLOYEES, onFilterEmployees); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate), fork(watchFilterEmployees)]);
}
